import Moment from 'moment';
import { useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../common/services/subscription/Actions';
import * as SubscriptionService from '../../../common/services/subscription/Service';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';

import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Notifications from 'react-notification-system-redux';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
// import InlineSpinner from '../../../common/components/misc/InlineSpinner';
import { SubscriptionError } from '../../../common/services/subscription/Types';
import { ChargebeePlanDTO } from '../../../common/types/dto/ChargebeePlanDTO';
import { ChargebeeSubscriptionDTO } from '../../../common/types/dto/ChargebeeSubscriptionDTO';
import { CustomerDataDTO } from '../../../common/types/dto/CustomerDataDTO';
import { SubscriptionCreditNoteDTO } from '../../../common/types/dto/SubscriptionCreditNoteDTO';
import { SubscriptionInvoiceDTO } from '../../../common/types/dto/SubscriptionInvoiceDTO';
import { SubscriptionItemDTO } from '../../../common/types/dto/SubscriptionItemDTO';
import { Utils } from '../../../common/utils';
import BuildDynamicTable from '../components/DynamicTable/DynamicTable';
import Accordion from './Accordion/Accordion';
import cssHistory from './ShowDetails/CarHistory/CarHistory.scss';
import css from './SubscriptionContract.scss';
import { SubscrStatusEnum } from './Types';

interface VehicleSubscriptionState {
    getActivePlans: ChargebeePlanDTO[] | undefined;
    getSubscriptionItems: SubscriptionItemDTO[] | undefined;
    getUserSubscriptions: ChargebeeSubscriptionDTO[] | undefined;
    getUserSubscriptionInvoices: SubscriptionInvoiceDTO[] | undefined;
    getUserSubscriptionCreditNotes: SubscriptionCreditNoteDTO[] | undefined;
    vehcode: number;
    submitErrorText: string;
}

export interface VehicleSubscriptionProps {
    vehcode: number;
    isLanding?: boolean;
    isTugaIframe?: boolean;
}

interface ReduxStateProps {
    getActivePlans: ChargebeePlanDTO[];
    isCommunicatingGetActivePlans: boolean;
    getSubscriptionItems: SubscriptionItemDTO[];
    isCommunicatingGetSubscriptionItems: boolean;
    getUserSubscriptions: ChargebeeSubscriptionDTO[];
    isCommunicatingGetUserSubscriptions: boolean;
    getUserSubscriptionInvoices: SubscriptionInvoiceDTO[];
    isCommunicatingGetUserSubscriptionInvoices: boolean;
    getUserSubscriptionCreditNotes: SubscriptionCreditNoteDTO[];
    isCommunicatingGetUserSubscriptionCreditNotes: boolean;
    cancelSubscription: ChargebeeSubscriptionDTO;
    isCommunicatingCancelSubscription: boolean;
    printSubscriptionInvoiceIsCommunicating: boolean;
    printSubscriptionInvoice: Blob | undefined;
    printSubscriptionCreditNoteIsCommunicating: boolean;
    printSubscriptionCreditNote: Blob | undefined;
    customerInfo: CustomerDataDTO | undefined;
    dispatch: AppThunkDispatch;
}

interface ReduxDispatchProps {
    subscriptionActions: typeof Actions;
    subscriptionServiceActions: SubscriptionService.ServiceActions;
}

type VehicleSubscriptionProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & VehicleSubscriptionProps;

const VehicleSubscription: React.FC<VehicleSubscriptionProperties> = (Props) => {
    const initialState: VehicleSubscriptionState = {
        getActivePlans: undefined,
        getSubscriptionItems: undefined,
        getUserSubscriptions: undefined,
        getUserSubscriptionInvoices: undefined,
        getUserSubscriptionCreditNotes: undefined,
        vehcode: -1,
        submitErrorText: '',
    };
    const [state, setState]: [VehicleSubscriptionState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );
    const { t } = useTranslation();

    useEffect(() => {
        if (Props.customerInfo && (Props.customerInfo.vehicles == null || Props.customerInfo.vehicles.length === 0)) {
            setState({ vehcode: -2});
        }
    }, [Props.customerInfo]);

    useEffect(() => {
        if (!state.getActivePlans && !state.getSubscriptionItems && !state.getUserSubscriptions && !state.getUserSubscriptionInvoices && !state.getUserSubscriptionCreditNotes && (!Props.vehcode || Props.vehcode === -1)) {
            setState({
                getActivePlans: [],
                getSubscriptionItems: [],
                getUserSubscriptions: [],
            });
        } else {
            if (Props.vehcode === state.vehcode) {
                return;
            }
            const isNotFirstVeh = Props.vehcode > 0 && state.vehcode > 0;
            if (!isNotFirstVeh) {
                setState({
                    vehcode: Props.vehcode,
                    getActivePlans: undefined,
                    getSubscriptionItems: undefined,
                    getUserSubscriptions: undefined,
                    getUserSubscriptionInvoices: undefined,
                    getUserSubscriptionCreditNotes: undefined,
                    submitErrorText: '',
                });

                try {
                    Props.subscriptionServiceActions.getSubscriptionItems();
                    Props.subscriptionServiceActions.getActivePlans();
                    if (!Props.isLanding) {
                        Props.subscriptionServiceActions.getUserSubscriptions();
                        Props.subscriptionServiceActions.getUserSubscriptionInvoices();
                        Props.subscriptionServiceActions.getUserSubscriptionCreditNotes();
                    }
                } catch (error) {
                    let exceptionErrorMsg: string = t('exception:UnknownException');
                    if (error instanceof SubscriptionError) {
                        const exceptionType: string = error.subscriptionErrorInfo.exceptionType || 'UnknownException';
                        exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
                    }
                    setState({
                        submitErrorText: exceptionErrorMsg,
                        getActivePlans: [],
                        getSubscriptionItems: [],
                        getUserSubscriptions: [],
                        getUserSubscriptionInvoices: [],
                        getUserSubscriptionCreditNotes: [],
                    });
                    Props.dispatch(Notifications.error({
                        title: t('error'),
                        message: exceptionErrorMsg,
                        position: 'tc',
                        autoDismiss: 5,
                    }));
                }
            } else {
                setState({
                    vehcode: Props.vehcode,
                    submitErrorText: '',
                });
            }
        }
    });

    useEffect(() => {
        if (Props.getActivePlans) {
            setState({ getActivePlans: Props.getActivePlans });
        }
    }, [Props.getActivePlans]);

    useEffect(() => {
        if (Props.getSubscriptionItems) {
            setState({ getSubscriptionItems: Props.getSubscriptionItems });
        }
    }, [Props.getSubscriptionItems]);

    useEffect(() => {
        if (Props.getUserSubscriptions) {
            setState({ getUserSubscriptions: Props.getUserSubscriptions });
        }
    }, [Props.getUserSubscriptions]);

    useEffect(() => {
        if (Props.getUserSubscriptionInvoices) {
            setState({ getUserSubscriptionInvoices: Props.getUserSubscriptionInvoices });
        }
    }, [Props.getUserSubscriptionInvoices]);

    useEffect(() => {
        if (Props.printSubscriptionInvoice && !Props.printSubscriptionInvoiceIsCommunicating) {
            Utils.saveData(Props.printSubscriptionInvoice, 'invoice.pdf');
        }
    }, [Props.printSubscriptionInvoice, Props.printSubscriptionInvoiceIsCommunicating]);

    useEffect(() => {
        if (Props.getUserSubscriptionCreditNotes) {
            setState({ getUserSubscriptionCreditNotes: Props.getUserSubscriptionCreditNotes });
        }
    }, [Props.getUserSubscriptionCreditNotes]);

    useEffect(() => {
        if (Props.printSubscriptionCreditNote && !Props.printSubscriptionCreditNoteIsCommunicating) {
            Utils.saveData(Props.printSubscriptionCreditNote, 'credit_note.pdf');
        }
    }, [Props.printSubscriptionCreditNote, Props.printSubscriptionCreditNoteIsCommunicating]);

    function SubscriptionHistoryItem(props: ChargebeeSubscriptionDTO) {
        const planTmp = Props.getActivePlans && Props.getActivePlans.find((x) => x.id === props.planId);
        return (
            <div className={cssHistory.mainContent}>

                <div className={css.row}>

                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.createdAt')}</label>
                        <div className={cssHistory.badge}>
                            {props.createdAt && <h3>{Moment(props.createdAt).format('DD/MM/YYYY')}</h3>}
                        </div>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.vin')}</label>
                        <br />
                        <text className={css.textCustom}>{props.vin}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.status')}</label>
                        <br />
                        <text className={css.textCustom}>{t(`subscriptions:subscStatus.${SubscrStatusEnum[props.status]}`)}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.planName')}</label>
                        <br />
                        <text className={css.textCustom}>{planTmp && planTmp.name}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.updatedAt')}</label>
                        <br />
                        <text className={css.textCustom}>{props.updatedAt && Moment(props.updatedAt).format('DD/MM/YYYY')}</text>
                    </div>
                </div>
            </div>
        );
    }

    async function PrintInvoicePdf(e: React.MouseEvent<{}> | null, invoiceCode: number) {
        if (e) {
            e.preventDefault();
        }
        if (Props.printSubscriptionInvoiceIsCommunicating) {
            return;
        }

        try {
            const subscriptionInvoiceBlob = await Props.subscriptionServiceActions.printSubscriptionInvoice(invoiceCode);
            if (!subscriptionInvoiceBlob) {
                throw new Error('result is Null');
            }
            Props.dispatch(Notifications.success({
                title: t('success'),
                message: t('subscriptions:success-print-invoice'),
                position: 'tc',
                autoDismiss: 5,
            }));
        } catch (error) {
            let exceptionErrorMsg: string = t('exception:UnknownException');
            if (error instanceof SubscriptionError) {
                const exceptionType: string = error.subscriptionErrorInfo.exceptionType || 'UnknownException';
                exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
            }
            setState({ submitErrorText: `${exceptionErrorMsg}` });
            Props.dispatch(Notifications.error({
                title: t('error'),
                message: `${exceptionErrorMsg}`,
                position: 'tc',
                autoDismiss: 5,
            }));
        }
        return;
    }

    async function PrintCreditNotePdf(e: React.MouseEvent<{}> | null, creditNoteCode: number) {
        if (e) {
            e.preventDefault();
        }
        if (Props.printSubscriptionCreditNoteIsCommunicating) {
            return;
        }

        try {
            const subscriptionCreditNoteBlob = await Props.subscriptionServiceActions.printSubscriptionCreditNote(creditNoteCode);
            if (!subscriptionCreditNoteBlob) {
                throw new Error('result is Null');
            }
            Props.dispatch(Notifications.success({
                title: t('success'),
                message: t('subscriptions:success-print-credit-note'),
                position: 'tc',
                autoDismiss: 5,
            }));
        } catch (error) {
            let exceptionErrorMsg: string = t('exception:UnknownException');
            if (error instanceof SubscriptionError) {
                const exceptionType: string = error.subscriptionErrorInfo.exceptionType || 'UnknownException';
                exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
            }
            setState({ submitErrorText: `${exceptionErrorMsg}` });
            Props.dispatch(Notifications.error({
                title: t('error'),
                message: `${exceptionErrorMsg}`,
                position: 'tc',
                autoDismiss: 5,
            }));
        }
        return;
    }

    function InvoiceHistoryItem(props: SubscriptionInvoiceDTO) {
        return (
            <div className={cssHistory.mainContent}>

                <div className={css.row}>

                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.createdAt')}</label>
                        <div className={cssHistory.badge}>
                            {props.date && <h3>{Moment(props.date).format('DD/MM/YYYY')}</h3>}
                        </div>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.paidAt')}</label>
                        <br />
                        <text className={css.textCustom}>{props.paidAt ? Moment(props.paidAt).format('DD/MM/YYYY hh:mm:ss') : ''}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.status')}</label>
                        <br />
                        <text className={css.textCustom}>{t(`subscriptions:invoiceStatus.${props.status}`)}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.total')}</label>
                        <br />
                        <text className={css.textCustom}>{props.priceFormated} &euro;</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.pdfPrint')}</label>
                        <br />
                        {props.isInvoicePdfReady ?
                            <a href="#" onClick={(e) => PrintInvoicePdf(e, props.code)}>{<FontAwesomeIcon icon={faDownload} />}</a> :
                            <text className={css.textCustom}>{t('subscriptions:sub-history.pdfNotAvailable')}</text>}
                    </div>
                </div>
            </div>
        );
    }

    function CreditNoteHistoryItem(props: SubscriptionCreditNoteDTO) {
        return (
            <div className={cssHistory.mainContent}>

                <div className={css.row}>

                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.createdAt')}</label>
                        <div className={cssHistory.badge}>
                            {props.date && <h3>{Moment(props.date).format('DD/MM/YYYY')}</h3>}
                        </div>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.status')}</label>
                        <br />
                        <text className={css.textCustom}>{t(`subscriptions:creditNoteStatus.${props.status}`)}</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.total')}</label>
                        <br />
                        <text className={css.textCustom}>{props.priceFormated} &euro;</text>
                    </div>
                    <div className={css.inputBreak}>
                        <label>{t('subscriptions:sub-history.pdfPrint')}</label>
                        <br />
                        {props.isCreditNotePdfReady ?
                            <a href="#" onClick={(e) => PrintCreditNotePdf(e, props.code)}>{<FontAwesomeIcon icon={faDownload} />}</a> :
                            <text className={css.textCustom}>{t('subscriptions:sub-history.pdfNotAvailable')}</text>}
                    </div>
                </div>
            </div>
        );
    }

    const subscrHistory = Props.getUserSubscriptions.map((x: ChargebeeSubscriptionDTO, idx: any) => {
        return (<SubscriptionHistoryItem {...x} key={`subhist${idx}`} />);
    });

    const invoicesHistory = Props.getUserSubscriptionInvoices.map((x: SubscriptionInvoiceDTO, idx: any) => {
        return (<InvoiceHistoryItem {...x} key={`subhist${idx}`} />);
    });

    const creditNotesHistory = Props.getUserSubscriptionCreditNotes.map((x: SubscriptionCreditNoteDTO, idx: any) => {
        return (<CreditNoteHistoryItem {...x} key={`subhist${idx}`} />);
    });

    return (
        <React.Fragment>
            <div className="error-message">{state.submitErrorText}</div>

            {/* <Loading /> */}
            <BuildDynamicTable
                getActivePlans={state.getActivePlans}
                getSubscriptionItems={state.getSubscriptionItems}
                getUserSubscriptions={state.getUserSubscriptions}
                vehcode={state.vehcode}
                isLanding={Props.isLanding}
                isTugaIframe={Props.isTugaIframe}
            />
            {!Props.isTugaIframe && <div className={classNames(['cell', 'small-12', 'text-left', 'pacote-prime-faq-title'])}>
                <hr />
                <h3>{t('subscriptions:faq.title')}</h3>
                <p>{t('subscriptions:faq.sub-title')}</p>
                <hr />
            </div>}

            {!Props.isTugaIframe && <div className={classNames(['cell', 'small-12', 'text-left', 'pacote-prime-faq-acordeao'])}>
                <ul className={'accordion'}>
                    <Accordion
                        title={t('subscriptions:faq.question1')}
                        content={t('subscriptions:faq.answer1')}
                    />
                    <Accordion
                        title={t('subscriptions:faq.question2')}
                        content={t('subscriptions:faq.answer2')}
                    />
                    <Accordion
                        title={t('subscriptions:faq.question3')}
                        content={t('subscriptions:faq.answer3')}
                    />
                    <Accordion
                        title={t('subscriptions:faq.question4')}
                        content={t('subscriptions:faq.answer4')}
                    />
                    <Accordion
                        title={t('subscriptions:faq.question5')}
                        content={t('subscriptions:faq.answer5')}
                    />
                </ul>
            </div>}

            {Props.getUserSubscriptions && Props.getUserSubscriptions.length > 0 && <div className={css.main}>

                <div className={css.more__questions}>
                    <h2>{t('subscriptions:history')}</h2>
                </div>
                <Tabs>
                    <TabList>
                        <Tab>{t('subscriptions:subscriptions')}</Tab>
                        <Tab>{t('subscriptions:invoices')}</Tab>
                        <Tab>{t('subscriptions:creditNotes')}</Tab>
                    </TabList>

                    <TabPanel>
                        {subscrHistory === null || subscrHistory.length === 0 ? <><br /><div className="info-message"><b>{t('subscriptions:notFound')}</b></div></> : subscrHistory}
                    </TabPanel>
                    <TabPanel>
                        {invoicesHistory === null || invoicesHistory.length === 0 ? <><br /><div className="info-message"><b>{t('subscriptions:notFound')}</b></div></> : invoicesHistory}
                    </TabPanel>
                    <TabPanel>
                        {creditNotesHistory === null || creditNotesHistory.length === 0 ? <><br /><div className="info-message"><b>{t('subscriptions:notFound')}</b></div></> : creditNotesHistory}
                    </TabPanel>
                </Tabs>

            </div>}
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    getActivePlans: store.subscriptionState.getActivePlans.data,
    isCommunicatingGetActivePlans: store.subscriptionState.getActivePlans.isCommunicating,
    getSubscriptionItems: store.subscriptionState.getSubscriptionItems.data,
    isCommunicatingGetSubscriptionItems: store.subscriptionState.getSubscriptionItems.isCommunicating,
    getUserSubscriptions: store.subscriptionState.getUserSubscriptions.data,
    isCommunicatingGetUserSubscriptions: store.subscriptionState.getUserSubscriptions.isCommunicating,
    getUserSubscriptionInvoices: store.subscriptionState.getUserSubscriptionInvoices.data,
    isCommunicatingGetUserSubscriptionInvoices: store.subscriptionState.getUserSubscriptionInvoices.isCommunicating,
    getUserSubscriptionCreditNotes: store.subscriptionState.getUserSubscriptionCreditNotes.data,
    isCommunicatingGetUserSubscriptionCreditNotes: store.subscriptionState.getUserSubscriptionCreditNotes.isCommunicating,
    cancelSubscription: store.subscriptionState.cancelSubscription.data,
    isCommunicatingCancelSubscription: store.subscriptionState.cancelSubscription.isCommunicating,
    printSubscriptionInvoiceIsCommunicating: store.subscriptionState.printSubscriptionInvoice.isCommunicating,
    printSubscriptionInvoice: store.subscriptionState.printSubscriptionInvoice.data,
    printSubscriptionCreditNoteIsCommunicating: store.subscriptionState.printSubscriptionCreditNote.isCommunicating,
    printSubscriptionCreditNote: store.subscriptionState.printSubscriptionCreditNote.data,
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    subscriptionActions: bindActionCreators(Actions, dispatch),
    subscriptionServiceActions: SubscriptionService.bindServiceActionCreators(config, dispatch),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSubscription);
